<template lang="pug">
v-card.profile-card.rounded-lg(data-cy="profile__card")
  v-list-item.px-8.pt-4(three-line)
    v-list-item-avatar.white--text.h1.rounded-lg(tile, color="#212166", size="80") {{ initials }}
    v-list-item-content.mt-2.align-content-start
      v-list-item-title.h3 {{ fullName }}
      v-list-item-subtitle.h10.mb-2 {{ instance.email }}
      router-link.profile-card__edit.edit(
        v-if="$getSchemaAction('User', 'editMyUser')",
        :to="userEdit",
      )
        v-icon.primary--text.mr-1(size="18") mdi-pencil-outline
        span.h5 {{ $t('ProfileCard.editUser') }}
  v-card-text.pt-1
    v-container.pt-4
      v-divider.primary.mb-5
      g-select(
        :value="currentBusinessScope",
        @input="selectScope($event.businessScope)",
        :title="$t('ProfileCard.currentBusinessScope')",
        :items="businessScopes",
        :disabled="loading || loadingBS",
        item-text="businessScope.path",
        item-value="businessScopeId",
        return-object,
      )
      g-select(
        :title="$t('ProfileCard.defaultBusinessScope')"
        v-model="instance.businessScopeId",
        :items= "businessScopes",
        item-text="businessScope.path",
        item-value="businessScope.id",
        :disabled="loading || loadingBS",
        @input="save",
      )
      g-select(
        v-model="instance.defaultScreen",
        :items= "screens",
        :disabled="loading || !instance.businessScopeId",
        :title="$t('ProfileCard.defaultScreen')",
        item-text="name",
        item-value="name",
        @input="save",
      )
      g-select(
        v-model="language",
        :items="languages",
        :disabled="loading",
        :prepend-inner-icon="getIcon(language)",
        :title="$t('ProfileCard.selectLanguage')",
        @input="changeLocale"
      )
        template(v-slot:item="slotProps")
          div.d-flex
            v-icon(left) {{ getIcon(slotProps.item.value) }}
            span {{ slotProps.item.text }}
      v-divider.primary
      div.pt-8
        a(href="javascript:void(0)", @click="showPolicy = true").profile-card__privacy.d-block.mb-5
          v-icon.mr-2(size="16") $policy
          span.primary--text Privacy
        g-btn.ml-auto.d-block(
          color="primary", outlined, @click="logout", data-cy="profile__logout"
        ) {{ $t('ProfileCard.signOut') }}
          v-icon(right) mdi-arrow-right
    v-dialog(v-model="showPolicy", width="900")
      v-card
        app-policy
</template>

<style lang="scss" scoped>
.profile-card {
  max-width: 390px;
  &__edit {
    text-decoration: none;
  }
}
</style>

<script>
import axios from 'axios';
import AppPolicy from './Policy.vue';

export default {
  props: {
    initials: {
      type: String,
    },
    fullName: {
      type: String,
    },
    businessScopes: {
      type: Array,
      default: () => ([]),
    },
    loadingBS: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AppPolicy
  },
  data: () => ({
    showPolicy: false,
    language: undefined,
    instance: {},
    loading: true,
    screens: [],
    ignore: ["PackageProduct", "OrderContact", "File", "ExtraData", "Event", "ProcessTask", "ProductType",
            "ShipmentContact", "Tag", "TriggerAction", "PackageOrderLine", "OrderType", "OrderLineEvent",
            "ContactParty"],
    currentBusinessScope: null,
  }),
  computed: {
    uid() {
      return this.$store.state.user.user.uid;
    },
    userEdit() {
      return `/${this.$scope()}/User/${this.instance.uid}/edit`;
    },
    languages() {
      return [
        { text: 'English', value: 'en' },
        { text: 'Français', value: 'fr' },
      ];
    },
  },
  watch: {
    'instance.defaultBusinessScopeId': {
      immediate: true,
      handler(val) {
        this.screens = this.instance.screens ? this.instance.screens.filter(e => !this.ignore.find(_ => _ === e)) : null
        if(_.isNil(val)) return
      },
    },
  },

  methods: {
    changeLocale(lang) {
      this.$i18n.locale = lang;
      this.$selectLanguage(lang)
    },
    async save() {
      this.instance.UserRoleBusinessScopes = this.businessScopes
      try {
        this.loading = true;
        this.instance.entityState = 3;
        await axios.post('entity/graph', this.instance );
      } catch (e) {
        console.log(this.$cleanString(e));
      } finally {
        this.loading = false;
      }
    },
    selectScope (scope) {
      this.$selectBusinessScope(scope, this.$store)
      this.$updateSchema(this.$store, axios)
      this.$router.push({ name: 'home', params: { scope: scope.path }})
    },
    async load () {
      try {
        var endpoint = this.$fetchLoad(`User/${this.uid}`, true, 'UserRoleBusinessScopes.Role', 'UserRoleBusinessScopes.BusinessScope')
        this.instance = (await axios.get(endpoint, {
          _Entity: 'User',
          uid: this.uid
        })).data;
       } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    async logout () {
      this.$store.commit('USER');
      this.$store.commit('CONFIG');
      localStorage.clear();
      sessionStorage.clear();

      window.location.replace('/EORDER/api/Auth/InitiateSingleLogout');
    },
    getIcon(locale) {
      switch (locale) {
        case 'en': return '$usaFlag';
        case 'fr': return '$frFlag';
        default: return '$usaFlag';
      }
    },
  },
  async mounted () {
    await this.load();
    this.screens = this.$allNavigableScreens();
    this.screens.push({name: 'Workstation'});
    this.currentBusinessScope = parseInt(window.localStorage.getItem('BusinessScopeId'));
    this.language = this.$i18n.locale;
  }
}
</script>
